<template>
  <div>
    <!-- 上方主体 -->
    <div class="container_top" id="topCont" @mouseover="contMouse">
      <!-- 轮播图 -->
      <!-- 鼠标滚动@wheel="goWheel" -->
      <!-- @mousedown="goWheel($event)" @mousemove="wheelmove($event)" @mouseup="wheelup($event)" -->
      <div style="position: relative; z-index: 88">
        <el-carousel
          :interval="5000"
          height="100vh"
          direction="horizontal"
          :autoplay="homeNum == 0"
          ref="swiper"
          :loop="true"
        >
          <!-- trigger="click" -->
          <el-carousel-item
            v-for="(item, index) in homeInfo.carousel_chart"
            :key="index"
          >
            <img style="width: 100%" :src="item.imgUrl" alt="" />
          </el-carousel-item>
        </el-carousel>
        <div class="centreCont">
          <div class="centre" v-if="homeInfo.core_area">
            <div
              class="technology"
              @mouseover.stop="techMous('1')"
              @click="goNucleus('hx-1', homeInfo.core_area[0])"
            >
              <!-- 核心技术 -->
              <div class="technology-warpper">
                <div class="technology-title">
                  <img
                    v-show="!techOneflg"
                    :src="homeInfo.core_area[0].imgUrl"
                    alt=""
                  />
                  <img
                    v-show="techOneflg"
                    :src="homeInfo.core_area[0].imgUrlTwo"
                    alt=""
                  />
                  <h2 class="title-text">{{ homeInfo.core_area[0].title }}</h2>
                </div>
                <div class="technology-list">
                  <div
                    v-for="(item, index) in homeInfo.core_area[0].inputArr"
                    :key="index"
                  >
                    · {{ item }}
                  </div>
                  <!-- <div>· 移动安全智能系统</div>
                  <div>· IETS标识认证系统</div>
                  <div>· 自主可控安全芯片</div> -->
                  <!-- <div>· 系统安全</div>
                  <div>· 隐私安全</div> -->
                </div>
              </div>
            </div>

            <div class="line"></div>
            <div
              class="technology"
              @mouseover.stop="techMous('2')"
              @click="goNucleus('hx-2', homeInfo.core_area[1])"
            >
              <!-- 核心能力 -->
              <div class="technology-warpper">
                <div class="technology-title">
                  <img
                    v-show="!techTwoflg"
                    :src="homeInfo.core_area[1].imgUrl"
                    alt=""
                  />
                  <img
                    v-show="techTwoflg"
                    :src="homeInfo.core_area[1].imgUrlTwo"
                    alt=""
                  />
                  <h2 class="title-text">{{ homeInfo.core_area[1].title }}</h2>
                </div>
                <div class="technology-list">
                  <div
                    v-for="(item, index) in homeInfo.core_area[1].inputArr"
                    :key="index"
                  >
                    · {{ item }}
                  </div>
                  <!-- <div>· 系统底层开发能力</div>
                <div>· 软件开发定制能力</div>
                <div>· 硬件开发定制能力</div>
                <div>· 硬件生产制造能力</div>
                <div>· 密码和算法研发能力</div> -->
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div
              class="technology"
              @mouseover.stop="techMous('3')"
              @click="goNucleus('hx-3', homeInfo.core_area[2])"
            >
              <!-- 核心业务 :class="techThreeflg ? 'techHover' : ''"-->
              <div class="technology-warpper">
                <div class="technology-title">
                  <img
                    v-show="!techThreeflg"
                    :src="homeInfo.core_area[2].imgUrl"
                    alt=""
                  />
                  <img
                    v-show="techThreeflg"
                    :src="homeInfo.core_area[2].imgUrlTwo"
                    alt=""
                  />
                  <h2 class="title-text">{{ homeInfo.core_area[2].title }}</h2>
                </div>
                <div class="technology-list">
                  <div
                    v-for="(item, index) in homeInfo.core_area[2].inputArr"
                    :key="index"
                  >
                    · {{ item }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 企业服务 -->
      <div class="compe_cont" v-if="homeInfo.qiyefuwu">
        <div class="compe_tit">{{ homeInfo.qiyefuwu.name }}</div>
        <div class="compe_fy">{{ homeInfo.qiyefuwu.nameEn }}</div>
        <div class="compe_txt">
          {{ homeInfo.qiyefuwu.content }}
        </div>
        <div class="gateCont">
          <div
            v-for="(item, index) in homeInfo.qiyefuwu.list"
            :key="index"
            class="gateBox"
            @mouseenter="getActive(index)"
            :class="{ gateActive: item.status }"
          >
            <div
              class="gateImg"
              :class="item.status ? 'gateNone' : 'gateBlock'"
            >
              <div
                class="img_bg"
                :style="{ 'background-image': 'url(' + item.imgUrl + ')' }"
              >
                <div class="overlay">
                  <div>{{ item.title.substring(0, 4) }}</div>
                  <div>{{ item.title.substring(4) }}</div>
                </div>
              </div>
            </div>
            <div
              class="gateTxt"
              :class="item.status ? 'gateBlock' : 'gateNone'"
            >
              <img :src="item.imgUrl" alt="" />
              <div class="gateBotCont">
                <div>{{ item.contentTitle }}</div>
                <!-- style="white-space: pre-line" -->
                <div style="display: flex; gap: 20px">
                  <div style="flex-shrink: 0;">
                    <div
                      class="gateBotCont_Tit"
                      @click.stop="goEnterprise(index, 0)"
                    >
                      {{ item.content.split("\n")[0] }}
                    </div>
                    <div
                      class="gateBotCont_Tit"
                      @click.stop="goEnterprise(index, 1)"
                    >
                      {{ item.content.split("\n")[1] }}
                    </div>
                  </div>
                  <div style="flex-shrink: 0;">
                    <div
                      class="gateBotCont_Tit"
                      @click.stop="goEnterprise(index, 2)"
                    >
                      {{ item.content.split("\n")[2] }}
                    </div>
                    <div
                      class="gateBotCont_Tit"
                      @click.stop="goEnterprise(index, 3)"
                    >
                      {{ item.content.split("\n")[3] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gateBac"></div>
      </div>

      <!-- 政府服务 -->
      <div class="coreTechCont" ref="coreContAll" v-if="homeInfo.zhengfufuwu">
        <!-- 圆弧菜单 -->
        <!-- <CircleMenu :menus="menus" /> -->
        <div class="coreTech">
          <div class="compe_tit">{{ homeInfo.zhengfufuwu.name }}</div>
          <div class="compe_fy">{{ homeInfo.zhengfufuwu.nameEn }}</div>
          <div class="compe_txt">
            {{ homeInfo.zhengfufuwu.content }}
          </div>
        </div>

        <div class="coreSwiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide
              v-for="(item, index) in homeInfo.zhengfufuwu.list"
              :key="index"
              class="my_slide"
              :data-name="item.routingPath"
            >
              <img style="width: 100%" :src="item.imgUrl" alt="" />
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev swiper-button-white"></div>
          <div class="swiper-button-next swiper-button-white"></div>
        </div>
      </div>

      <!-- 定制服务 -->
      <div class="publicCloud" id="advantage02" v-if="homeInfo.dingzhifuwu">
        <div class="publ_compe_tit">{{ homeInfo.dingzhifuwu.name }}</div>
        <div class="publ_compe_fy">{{ homeInfo.dingzhifuwu.nameEn }}</div>
        <div class="publ_compe_txt">
          {{ homeInfo.dingzhifuwu.content }}
        </div>
        <div class="publCont">
          <div
            class="publ_img"
            v-for="(item, index) in homeInfo.dingzhifuwu.list"
            :key="index"
            @click="goCustom(item, index)"
          >
            <div class="img_Cont">
              <img :src="item.imgUrl" alt="" />
              <div class="img_Cont_Tit">{{ item.contentTitle }}</div>
              <div class="knowMore">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <div id="ces" v-html="cesHtml"></div>
      <!-- 新闻中心 -->
      <div
        class="publicCloud"
        id="groupComm"
        v-if="Object.keys(homeInfo).length > 0"
      >
        <div class="publ_compe_tit">{{ homeInfo.xinwenzhongxin.name }}</div>
        <div class="publ_compe_fy">{{ homeInfo.xinwenzhongxin.nameEn }}</div>
        <div
          class="publCont"
          @click="toDetails(homeInfo.xinwenzhongxin.list[0])"
        >
          <div class="publ_img">
            <img
              style="
                width: 1200px;
                height: 465px;
                object-fit: cover;
                object-position: center;
              "
              :src="homeInfo.xinwenzhongxin.list[0].imgUrl"
              alt=""
            />
            <div class="txtConts">
              <div class="img_Tit">
                {{ homeInfo.xinwenzhongxin.list[0].title }}
              </div>
              <div class="img_Txt">
                {{ homeInfo.xinwenzhongxin.list[0].contentTitle }}
              </div>
            </div>
            <div style="margin-left: 30px !important" class="knowMore">
              了解更多<i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="publCont">
          <div
            class="publ_newTit"
            v-for="(item, index) in homeInfo.xinwenzhongxin.list"
            :key="index"
          >
            <div class="publ_img" v-if="index != 0" @click="toDetails(item)">
              <div class="img_Cont">
                <img :src="item.imgUrl" alt="" />
                <div class="img_Cont_Tit">{{ item.contentTitle }}</div>
                <div class="knowMore">
                  了解更多<i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="publCont" style="justify-content: end">
          <div class="know" @click="goMoreInquiy">
            更多资讯<i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
    <div id="mobile">
      <m-home />
    </div>
  </div>
</template>

<script>
import MHome from "@/views/mobile/home.vue";
import bg5 from "@/assets/images/5.png"
import CircleMenu from "./circleMenue.vue";
// import Swiper from "swiper";
import { homeIndex, treeselect } from "@/api/index";
var vm = null;
export default {
  props: { barNum: Number },
  components: {
    CircleMenu,
    MHome,
  },
  data() {
    return {
      homeNum: 0,
      homeInfo: {},
      tellValue: "",
      emailValue: "",
      cesswipe: {
        loop: true,
        centeredSlides: true,
        slidesPerView: 2,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
          clickable: true,
        },
      },

      swiperOption: {
        grabCursor: true,

        // 滑动方向
        direction: "horizontal",

        // 衔接滑动
        loop: true,
        // 自动滑动
        autoplay: {
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换。
          stopOnLastSlide: false,
          // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
          disableOnInteraction: false,
        },

        // 切换效果 "coverflow"（3d流）
        // effect: 'coverflow',

        // 设置slider容器能够同时显示的slides数量
        slidesPerView: "auto",
        //slider容器相互之间距离
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
        // centeredSlides: true,
        on: {
          click: function () {
            // console.log(
            //   this.clickedSlide.dataset,
            //   this.clickedSlide.dataset.name
            // );
            if (this.clickedSlide && this.clickedSlide.dataset) {
              vm.goGave(
                this.clickedSlide.dataset.swiperSlideIndex,
                this.clickedSlide.dataset.name
              );
            }
          },
        },

        // 设置为true则点击slide会过渡到这个slide。
        // slideToClickedSlide: true,

        // effect: "coverflow",
        // slidesPerView: 3,
        // centeredSlides: true,

        // coverflowEffect: {
        //   // slide做3d旋转时Y轴的旋转角度
        //   rotate: 0,
        //   // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
        //   stretch: 0,
        //   // slide的位置深度。值越大z轴距离越远，看起来越小。
        //   depth: 60,
        //   // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
        //   modifier: 5,
        //   // 是否开启slide阴影
        //   slideShadows: true
        // },
        freeMode: true,
        freeModeFluid: true,
        momentumRatio: 5,
      },

      uploadImg: 0,
      clientX: 0,
      chooseIndex: 0,
      // menus: [
      //   {
      //     name: "移动安全智能系统",
      //     desc: "MOBILE SECURITY INTELLIGENCE SYSTEM",
      //   },
      //   {
      //     name: "测试菜单2",
      //     desc: "测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明",
      //   },
      //   {
      //     name: "测试菜单3",
      //     desc: "测试菜单3说明",
      //   },
      //   {
      //     name: "测试菜单4",
      //     desc: "测试菜单4说明测试菜单4说明测试菜单4说明",
      //   },
      //   {
      //     name: "测试菜单5",
      //     desc: "测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明测试菜单1说明",
      //   },
      //   {
      //     name: "测试菜单6",
      //     desc: "测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明测试菜单2说明",
      //   },
      //   {
      //     name: "测试菜单7",
      //     desc: "测试菜单3说明",
      //   },
      //   {
      //     name: "测试菜单8",
      //     desc: "测试菜单4说明测试菜单4说明测试菜单4说明",
      //   },
      // ],
      tapHomeFlg: false,
      tapNum: 0,
      textLeftFlg: false,
      textRightFlg: false,
      coreContFlg: false,
      gateFlgAll: {
        gateaFlg: true,
        gatebFlg: false,
        gatecFlg: false,
        gatedFlg: false,
      },
      imageUrl: [
        "https://oss.jingshucloud.com/gw-bucket/785235c6-bd07-4c38-9c58-576118fb4db8.png",
        "https://oss.jingshucloud.com/gw-bucket/d6e30e7d-68a3-4cd3-8cfb-b20e1a9c914a.png",
        "https://oss.jingshucloud.com/gw-bucket/0a4586b4-cb4d-4548-a04d-1e8091b31008.png",
        "https://oss.jingshucloud.com/gw-bucket/62b7838c-1946-4c2e-a7a7-eb40a9d46541.png",
      ],
      techOneflg: false,
      techTwoflg: false,
      techThreeflg: false,
      cesHtml: "",
    };
  },
  computed: {},
  watch: {
    barNum(n, o) {
      //n为新值,o为旧值;
      // console.log(n,o,"下午");
      this.homeNum = n;
    },
    switchNum(curVal, oldVal) {
      // console.log(curVal, oldVal);
      if (curVal == 1) {
        document.getElementById("kinds").scrollIntoView({ behavior: "smooth" });
      }
      if (curVal == 99) {
        document
          .getElementById("topCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  beforeMount() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // new Swiper(".swiper-container", {
    //   // pagination: {
    //   //   el: ".swiper-pagination",
    //   // },
    //   //变手
    //   grabCursor: true,

    //   // 滑动方向
    //   // direction: 'horizontal',

    //   // 衔接滑动
    //   loop: true,
    //   // 自动滑动
    //   autoplay: {
    //     delay: 5000,
    //     // 如果设置为true，当切换到最后一个slide时停止自动切换。
    //     stopOnLastSlide: false,
    //     // 如果设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay
    //     disableOnInteraction: false,
    //   },
    //   // 切换效果 "coverflow"（3d流）
    //   // effect: 'coverflow',

    //   // 设置slider容器能够同时显示的slides数量
    //   slidesPerView: "auto",
    //   //slider容器相互之间距离
    //   spaceBetween: 20,

    //   // 居中幻灯片。设定为true时，当前的active slide 会居中，而不是默认状态下的居左。
    //   centeredSlides: true,

    //   // 设置为true则点击slide会过渡到这个slide。
    //   slideToClickedSlide: true,

    //   // coverflowEffect: {
    //   //   // slide做3d旋转时Y轴的旋转角度
    //   //   rotate: 0,
    //   //   // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
    //   //   stretch: 0,
    //   //   // slide的位置深度。值越大z轴距离越远，看起来越小。
    //   //   depth: 60,
    //   //   // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
    //   //   modifier: 5,
    //   //   // 是否开启slide阴影
    //   //   slideShadows: true
    //   // },

    //   freeMode: true,
    //   freeModeFluid: true,
    //   momentumRatio: 5,
    // });
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    this.homeNum = this.barNum;
    // console.log("水电费",this.homeNum);
    vm = this;
    if (this.switchNum == 99) {
      document.getElementById("topCont").scrollIntoView({ behavior: "smooth" });
    }
    homeIndex().then((res) => {
      // console.log(res.data.data, "测试首页数据");
      this.homeInfo = res.data.data;
      this.homeInfo.qiyefuwu.list = [
          {
            createBy: null,
            createTime: '2023-11-23 18:08:58',
            updateBy: null,
            updateTime: '2024-08-16 13:46:27',
            remark: null,
            id: 1,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业安全通讯与系统',
            titleEn: 'commitment',
            contentTitle: '企业安全通讯与系统',
            content: '企业集群安全通讯\n终端双域操作系统\n企业私有通讯系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/785235c6-bd07-4c38-9c58-576118fb4db8.png',
            sortOrder: 1,
            status: true,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2023-11-23 18:09:45',
            updateBy: null,
            updateTime: '2024-08-16 13:46:48',
            remark: null,
            id: 2,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业移动办公自动化',
            titleEn: 'innovate',
            contentTitle: '企业移动办公自动化',
            content: '移动安全办公系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/d6e30e7d-68a3-4cd3-8cfb-b20e1a9c914a.png',
            sortOrder: 2,
            status: false,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2024-01-10 14:53:19',
            updateBy: null,
            updateTime: '2024-08-16 13:47:13',
            remark: null,
            id: 3,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业信息化管理',
            titleEn: null,
            contentTitle: '企业信息化管理',
            content: '企业数据管理EMM\n物联网管理系统',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/0a4586b4-cb4d-4548-a04d-1e8091b31008.png',
            sortOrder: 3,
            status: false,
            routingPath: null
          },
          {
            createBy: null,
            createTime: '2024-01-10 14:53:44',
            updateBy: null,
            updateTime: '2024-08-16 13:47:38',
            remark: null,
            id: 4,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业安全定制',
            titleEn: null,
            contentTitle: '企业安全定制与采购服务',
            content: '移动终端定制\n智能设备定制\n安全系统定制\n安全软件定制',
            imgUrl:
              'https://oss.jingshucloud.com/gw-bucket/62b7838c-1946-4c2e-a7a7-eb40a9d46541.png',
            sortOrder: 4,
            status: false,
            routingPath: null
          },
          {
            id: 5,
            moduleId: 1,
            moduleName: '企业服务',
            title: '企业采购方案',
            titleEn: null,
            contentTitle: '企业采购方案',
            content: '月付模式\n一次性买断\n分期付款\n研发后置',
            imgUrl: bg5,
            sortOrder: 5,
            status: false,
            routingPath: null
          }
        ]
      console.log(this.homeInfo.qiyefuwu.list)
      // this.$set(this.homeInfo,res.data.data)
    });

    // console.log("测少时诵诗书", this.$route.name);

    // 解码

    // var item = JSON.parse(decodeURIComponent(escape(window.atob(data))));
    // // 编码
    // var data = window.btoa(unescape(encodeURIComponent(JSON.stringify(item))));
    // let ser = "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";
    // this.cesHtml = decodeURI(atob(ser));;

    this.$store.commit("changeTabCheck", {
      idNum: "99",
      sumName: this.$route.name,
    });
    this.$store.state.enterp_somFlg = "";
  },
  methods: {
    toDetails(row) {
      this.$router.push({
        name: "myHome/companyConsulting/newsDetails",
        // params: { info: row.content },
        params: { id: row.id },
      });
      this.$store.commit("changeTabCheck", {
        idNum: "",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    goMoreInquiy() {
      this.$router.push({
        name: "myHome/companyConsulting",
        params: {},
      });
      this.$store.commit("changeTabCheck", {
        idNum: "",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    contMouse() {
      this.techOneflg = false;
      this.techTwoflg = false;
      this.techThreeflg = false;
    },
    goGave(row, name) {
      let sum = parseInt(row) + 1;
      let num = "3-" + sum;
      // console.log("测试点击", num);
      this.$router.push({
        name: name,
        params: {},
      });
      this.$store.commit("changeTabCheck", {
        idNum: num,
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
      return;
      if (num == "3-1") {
        this.$router.push({
          name: "goveHome/governmentalService",
          params: {},
        });
      } else if (num == "3-2") {
        this.$router.push({
          name: "goveHome/goveSoftware",
          params: {},
        });
      } else if (num == "3-3") {
        this.$router.push({
          name: "goveHome/goveSI",
          params: {},
        });
      } else if (num == "3-4") {
        this.$router.push({
          name: "goveHome/goveCommunication",
          params: {},
        });
      } else if (num == "3-5") {
        this.$router.push({
          name: "goveHome/govePrivateComm",
          params: {},
        });
      } else if (num == "3-6") {
        this.$router.push({
          name: "goveHome/goveEmm",
          params: {},
        });
      }
    },
    handleScroll() {
      if (this.$refs.coreContAll && this.$refs.coreContAll.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.coreContAll.offsetTop
        // );
        // this.switchNum = 0
        this.$emit("switchflg", "0");
        if (window.scrollY > 700) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        if (window.scrollY > 1100) {
          this.textLeftFlg = true;
          this.textRightFlg = true;
        }
        if (window.scrollY > 2600) {
          this.coreContFlg = true;
        }
      }
    },
    techMous(row) {
      if (row == "1") {
        this.techOneflg = true;
        this.techTwoflg = false;
        this.techThreeflg = false;
      } else if (row == "2") {
        this.techOneflg = false;
        this.techTwoflg = true;
        this.techThreeflg = false;
      } else {
        this.techOneflg = false;
        this.techTwoflg = false;
        this.techThreeflg = true;
      }
    },
    goNucleus(row, info) {
      // console.log(row, info);
      // this.$router.push({
      //   name: "detailTempIndex/templateDetail",
      //   params: { info: info },
      // });
      switch (row) {
        case "hx-1":
          this.$router.push({
            name: "static/products",
            params: { info: info },
          });
          break;
        case "hx-2":
          this.$router.push({
            name: "static/abilities",
            params: { info: info },
          });
          break;
        case "hx-3":
          this.$router.push({
            name: "static/solutions",
            params: { info: info },
          });
          break;
        default:
          return;
      }
      this.$store.commit("changeTabCheck", {
        idNum: "",
        sumName: "detailTempIndex/templateDetail",
      });
      this.$store.state.enterp_somFlg = "";
    },
    // goGave(row) {
    //   console.log(row);
    //   this.$router.push({
    //     name: "goveHome/governmentalService",
    //     params: {},
    //   });
    //   this.$store.commit("changeTabCheck", {
    //     idNum: "",
    //     sumName: "goveHome/governmentalService",
    //   });
    //   this.$store.state.enterp_somFlg = "";
    // },
    goEnterprise(row, num) {
      console.log(row, num);
      if (row == 0 && num == 0) {
        this.$router.push({
          name: "/static/detail/enterpriseClusterSecurityCommunication",
          params: {},
        });
      } else if (row == 0 && num == 1) {
        this.$router.push({
          name: "/static/detail/dualDomainSystem",
          params: {},
        });
      } else if (row == 0 && num == 2) {
        this.$router.push({
          name: "/static/detail/enterprisePrivateCommunicationSystem",
          params: {},
        });
      } else if (row == 1 && num == 0) {
        this.$router.push({
          name: "/static/detail/safeOffice",
          params: {},
        });
      } else if (row == 1 && num == 1) {
        this.$router.push({
          name: "enterpriseHome/enterpriseSmartOffice",
          params: {},
        });
      } else if (row == 2 && num == 0) {
        this.$router.push({
          name: "/static/detail/EMM",
          params: {},
        });
      } else if (row == 2 && num == 1) {
        this.$router.push({
          name: "/static/detail/iotSystem",
          params: {},
        });
      } else if (row == 3 && num == 0) {
        this.$router.push({
          name: "/static/detail/mobileTerminalCustom",
          params: {},
        });
      } else if (row == 3 && num == 1) {
        this.$router.push({
          name: "/static/detail/intelligentDeviceCustom",
          params: {},
        });
      } else if (row == 3 && num == 2) {
        this.$router.push({
          name: "/static/detail/safeSystemCustom",
          params: {},
        });
      } else if (row == 3 && num == 3) {
        this.$router.push({
          name: "/static/detail/safeSoftwareCustom",
          params: {},
        });
      } else if (row == 4 && num == 0) {
        this.$router.push({
          name: "/static/detail/payByMonth",
          params: {},
        });
      } else if (row == 4 && num == 1) {
        this.$router.push({
          name: "/static/detail/payOneTime",
          params: {},
        });
      } else if (row == 4 && num == 2) {
        this.$router.push({
          name: "/static/detail/paySplit",
          params: {},
        });
      } else if (row == 4 && num == 3) {
        this.$router.push({
          name: "/static/detail/payBefore",
          params: {},
        });
      }
      this.$store.commit("changeTabCheck", {
        idNum: "",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    goCustom(row, num) {
      let name = row.title == "私人定制" ? 6 : 59;
      this.$router.push({
        name: row.routingPath,
        params: { flgId: num + 1, id: name },
        // params: { id: num },
      });
      // if (row == "4-1") {
      //   this.$router.push({
      //     name: "customizeHome/customizeEnterprise",
      //     params: { id: 0 },
      //   });
      // } else {
      //   this.$router.push({
      //     name: "customizeHome/customizeEnterprise",
      //     params: { id: 1 },
      //   });
      // }

      this.$store.commit("changeTabCheck", {
        idNum: "",
        sumName: "",
      });
      this.$store.state.enterp_somFlg = "";
    },
    getActive(row) {
      this.homeInfo.qiyefuwu.list.forEach((item, index) => {
        if (row == index) {
          item.status = true;
        } else {
          item.status = false;
        }
      });
      // if (row == 0) {
      //   this.gateFlgAll.gateaFlg = true;
      //   this.gateFlgAll.gatebFlg = false;
      //   this.gateFlgAll.gatecFlg = false;
      //   this.gateFlgAll.gatedFlg = false;
      // }
      // if (row == 1) {
      //   this.gateFlgAll.gatebFlg = true;
      //   this.gateFlgAll.gateaFlg = false;
      //   this.gateFlgAll.gatecFlg = false;
      //   this.gateFlgAll.gatedFlg = false;
      // }
      // if (row == 2) {
      //   this.gateFlgAll.gatecFlg = true;
      //   this.gateFlgAll.gatebFlg = false;
      //   this.gateFlgAll.gateaFlg = false;
      //   this.gateFlgAll.gatedFlg = false;
      // }
      // if (row == 3) {
      //   this.gateFlgAll.gatedFlg = true;
      //   this.gateFlgAll.gatebFlg = false;
      //   this.gateFlgAll.gatecFlg = false;
      //   this.gateFlgAll.gateaFlg = false;
      // }
    },
    //监听鼠标抬起
    wheelup(row) {
      // console.log("测试wheelup",row);
    },
    //监听鼠标滑动时刻
    wheelmove(row) {
      // console.log("测试wheelmove",row);
      // console.log(this.clientX,row.clientX,"测试");
      // this.clientX = row.clientX-this.clientX
    },
    //监听鼠标按下
    goWheel(row) {
      // this.clientX = row.clientX
      // console.log(this.clientX,"测试第一次",row);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-carousel__item {
  overflow: visible;
}
/deep/.el-carousel--horizontal {
  overflow: visible;
}
.telImg {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .telImgCont {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    flex-direction: column;
  }
  .telImgCont img {
    // width: 1691px;
    width: 100%;
    // position: absolute;
    // z-index: 0;
  }
  .tellTxtCont {
    // width: 1691px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 20px;
    /*  小屏适配 */
    // width: 86%;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
  }
  .tellText {
    position: absolute;
    top: 100px;
    left: 7.6%;
    font-size: 38px;
    color: rgb(255, 255, 255);
    // width: 200px;
    /*  小屏适配 */
    left: 0;
  }
  .posReal {
    position: relative;
    display: table;
    white-space: nowrap;
  }
  .botWire::before {
    content: "";
    height: 1px;
    background: #fff;
    position: absolute;
    top: 51px;
    width: 100%;
  }
  .tellInput {
    position: absolute;
    top: 100px;
    right: 8%;
    width: 410px;
    height: 57px;
    border: 1px solid #fff;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 30px;
    padding: 0 20px;
    justify-content: space-between;
    /*  小屏适配 */
    right: 0;
    /deep/ .el-input__inner {
      border: transparent;
      background: transparent;
      color: #fff;
      font-size: 22px;
    }
    /deep/.el-input__inner::placeholder {
      color: #fff;
      font-size: 22px;
    }
  }
  .emailInput {
    position: absolute;
    top: 180px;
    right: 8%;
    width: 410px;
    height: 57px;
    border: 1px solid #fff;
    color: #000;
    display: flex;
    align-items: center;
    font-size: 30px;
    background: #fff;
    padding: 0 20px;
    justify-content: space-between;
    /*  小屏适配 */
    right: 0;
    /deep/ .el-input__inner {
      border: transparent;
      background: transparent;
      color: #000;
      font-size: 22px;
    }
    /deep/.el-input__inner::placeholder {
      color: #000;
      font-size: 22px;
    }
  }
}

// 方案介绍
.publicCloud {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 10px 0px 10px;
  .publ_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .publ_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }
  .publ_compe_fy {
    font-size: 20px;
    color: #8a8c91;

    // 文字渐变
    // background: linear-gradient(to top, #ffffff 0%, #ffffff 25%, #f4ca80 100%);
    // background-clip: text;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .publ_compe_txt {
    width: 100%;
    margin: 60px 0 0px 0;
    text-align: center;
    font-size: 20px;
    max-width: 1200px;
  }

  .publCont {
    display: flex;
    justify-content: center;
    // align-items: center;
    // margin: 80px;
    // flex-wrap: wrap;
    // width: 1460px;
    /*  小屏适配 */
    // width: 90%;
    width: 100%;
    max-width: 1230px;
    margin: 0px auto;
    margin-top: 60px;
  }
  .publ_newTit {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .publ_img {
    margin: 0 15px;
    position: relative;
    // width: 22%;
    // height: 383px;
    overflow: hidden;
    cursor: pointer;
  }
  .publ_img img {
    display: block;

    transition: ease all 0.3s;
    width: 100%;
    height: 101%;
    position: relative;
  }
  .shadePubl {
    display: none;
    display: block;
    position: absolute; /* 设置绝对定位 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .publ_img:hover {
    .shadePubl {
      display: block;
      position: absolute; /* 设置绝对定位 */
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background-color: rgba(0, 0, 0, 0.2);
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
      z-index: 1;
    }
  }
  .publ_img::before {
    content: "";
    display: block;
    position: absolute; /* 设置绝对定位 */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgba(0, 0, 0, 0.2);
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.4) 100%
    );
    z-index: 1;
  }
  .publ_img:hover::before {
    // background-color: rgba(0, 0, 0, 0.4) !important;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.7) 100%
    );
  }
  .publ_img:hover img {
    transform: scale(1.1);
  }

  // .publ_img div {
  //   margin-top: 20px;
  // }
  .img_Cont {
    position: relative;
  }
  .img_Tit {
    position: absolute;
    bottom: 69px;
    color: #fff;
    font-size: 20px;
    margin-left: 30px;
    cursor: pointer;
    z-index: 2;
  }
  .img_Txt {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    position: absolute;
    bottom: 30px;
    color: #fff;
    font-size: 16px;
    margin-left: 30px;
    cursor: pointer;
    z-index: 2;
  }

  .img_Cont_Tit {
    position: absolute;
    bottom: 20px;
    color: #fff;
    font-size: 20px;
    margin-left: 20px;
    z-index: 2;
    transition: all 0.3s ease-in-out;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  .publ_img:hover .img_Cont_Tit {
    bottom: 45px !important;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .txtConts {
    position: absolute;
    bottom: 0px;
    color: #fff;
    font-size: 20px;
    margin-left: 0;
    cursor: pointer;
    z-index: 2;
    width: 100%;
    transition: all 0.3s ease-in-out;
  }
  .publ_img:hover .txtConts {
    bottom: 45px !important;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .publ_img:hover .knowMore {
    // bottom: 10px !important;
    // display: block;
    height: 40px;
    opacity: 1;
    // display: flex;
    // justify-content: center;
    // align-content: center;
  }
  .knowMore {
    position: absolute;
    height: 0;
    // bottom: 40px;
    color: #fff;
    font-size: 16px;
    margin-left: 20px;
    transition: all 0.3s ease-in-out;
    // bottom: -65px !important;
    bottom: 0px !important;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
  .know {
    cursor: pointer;
    margin: 5px;
    position: relative;
    text-decoration: none;
    display: table;
    white-space: nowrap;
  }
  .know::after {
    content: "";
    z-index: -1;
    position: absolute;
    background-color: #04758e;
    width: 100%;
    height: 8%;
    bottom: -2px;
    left: 0;
    visibility: hidden;
    transform: scaleX(0);
    transition: transform 0.2s ease-in-out;
  }
  .know:hover::after {
    visibility: visible;
    transform: scaleX(1);
  }
  .know:hover {
    color: #04758e;
    // text-decoration: underline;
  }
  .publ_Tit {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top: 20px;
  }
  .publ_Txt {
    text-align: justify;
  }
}

.compe_tit {
  font-size: 32px;
  font-weight: 600;
  color: #151a23;
  position: relative;
  margin-bottom: 20px;
}
.compe_tit::before {
  content: "";
  height: 1px;
  background: #151a23;
  position: absolute;
  top: 52px;
  width: 100%;
}
.compe_fy {
  font-size: 20px;
  color: #8a8c91;
}
.compe_txt {
  width: 100%;
  margin: 60px 0;
  text-align: center;
  font-size: 20px;
  max-width: 1200px;
}

.coreContAll {
  // height: 930px;
  padding: 80px 0;
  background: #f3f8ff;
  position: relative;
  .core_compe_cont {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 105px;
  }

  .coreCont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    z-index: 96;
  }
  .coreAnimCont {
    width: 100%;
    height: 100%;
    display: flex;
    // justify-content: center;
    align-items: center;
    flex-direction: column;
    background: rgb(255, 255, 255);
    border-radius: 5%;
    z-index: 999;
  }
  .coreAnimCont img {
    width: 25%;
    margin: 30px 0px;
  }
  .coreAnim {
    width: 260px;
    height: 305px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0 17px;
    border-radius: 5%;
    opacity: 0;
    /*  小屏适配 */
    width: 18%;
  }
  .triangle {
    width: 0;
    height: 0;
    border-top: 50px solid #fff;
    border-right: 35px solid transparent;
    border-left: 35px solid transparent;
    //
    position: absolute;
    bottom: -41px;
  }
  .homeBotImg {
    // width: 100%;
    // position: absolute;
    width: 1684px;
    // z-index: 35;
    // bottom: -59px;
  }
  // .drop_shad {
  //   filter: drop-shadow(0px 0px 2px #999);
  // }

  .coreAnim:hover {
    box-shadow: 0px 0px 5px #999;
  }
  .coreAnim:hover .drop_shad {
    filter: drop-shadow(0px 0px 2px #999);
  }

  @keyframes sequential {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .coreOne {
    animation: sequential 1.5s infinite;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
  }
  .coreTwo {
    animation: sequential 1.5s infinite 0.5s;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
    margin-bottom: 200px;
  }

  .coreThree {
    animation: sequential 1.5s infinite 1s;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
  }
  .coreFour {
    animation: sequential 1.5s infinite 1.5s;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
    margin-bottom: 200px;
  }
  .coreFive {
    animation: sequential 1.5s infinite 2s;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
  }
}

.gateCont::-webkit-scrollbar {
  width: 0; /* 隐藏滚动条 */
}
.gateCont::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
// 门闸动态效果

.gateBac {
  background: rgb(243, 248, 255);
  width: 100%;
  height: 160px;
  position: absolute;
  bottom: 0px;
  z-index: 22;
}
.gateCont {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 80px 0;
  z-index: 33;
  /*  小屏适配 */
  // width: 87%;
  width: 100%;
  max-width: 1200px;
  margin: 0px auto;
}
.img_bg {
  width: 550px;
  height: 485px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 40% 50%;
  position: relative;
}
.gateBox {
  width: 305px;
  // margin-left: 0;
  height: 485px;
  transition: all ease-out 0.4s;
  /*  小屏适配 */
  width: 18%;
}
.gateActive {
  width: 550px;
  /*  小屏适配 */
  width: 45%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // height: 550px;
  // margin-left: 1px;
}
.gateBlock {
  display: flex;
}
.gateNone {
  display: none;
}

.gateBotCont {
  // background: linear-gradient(360deg, #003365 0%, #048799 100%);
  background: #04758e;
  padding: 35px 25px;
  color: #fff;
  height: 90px;
  // width: 550px;
  line-height: 28px;
}
.gateBotCont_Tit {
  font-size: 20px;
  font-weight: 600;
  // margin-bottom: 14px;
  width: fit-content;
  cursor: pointer;
}

.gateTxt {
  justify-content: center;
  flex-direction: column;
}
.gateTxt img {
  height: 325px;
  // width: 550px;
}

.compe_cont {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // margin: 100px 0 60px 0;
  margin: 50px 0 60px 0;
  position: relative;
}

.tapOne {
  cursor: pointer;
  font-size: 20px;
  margin: 20px 40px;
}
.colr {
  // background: linear-gradient(360deg, #003365 0%, #048799 100%);
  position: relative;
  color: #048799;
}
.colr::before {
  content: "";
  height: 3px;
  background: #048799;
  position: absolute;
  top: 44px;
  width: 100%;
}

.sfce {
  position: absolute;
  width: 400px;
  height: 200px;
  border: 5px solid rgb(118, 218, 255);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(118, 218, 255);
  overflow: hidden;
}

.info {
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  top: 80%;
  border-radius: 55%;
  border: 0px solid red;
  left: 50%;
  transform: translate(-50%, 0);
}

// //海浪动画
.myWave {
  width: 100%;
  height: 200px;
  // outline: 2px dashed gray;
  --c: #2196f3;
  --w1: radial-gradient(100% 57% at top, #0000 100%, var(--c) 100.5%) no-repeat;
  --w2: radial-gradient(100% 57% at bottom, var(--c) 100%, #0000 100.5%)
    no-repeat;
  background: var(--w1), var(--w2), var(--w1), var(--w2);
  background-position-x: -200%, -100%, 0%, 100%;
  background-position-y: 100%;
  background-size: 50.5% 100%;
  animation: m 1s infinite linear;
}
@keyframes m {
  0% {
    background-position-x: -200%, -100%, 0%, 100%;
  }
  100% {
    background-position-x: 0%, 100%, 200%, 300%;
  }
}
section {
  position: relative;
  width: 100%;
}
section .waves {
  position: relative;
}
section .waves .wave {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100px;

  background-size: 1000px 100px;
}
section .wave#wave1 {
  z-index: 1000;
  opacity: 1;
  bottom: 0;
  animation: animate 4s linear infinite;
}
section .wave#wave2 {
  z-index: 999;
  opacity: 0.5;
  bottom: 10px;
  animation: animate2 4s linear infinite;
}
section .wave#wave3 {
  z-index: 998;
  opacity: 0.2;
  bottom: 15px;
  animation: animate 2s linear infinite;
}
section .wave#wave4 {
  z-index: 999;
  opacity: 0.7;
  bottom: 20px;
  animation: animate2 2s linear infinite;
}

@keyframes animate {
  0%,
  100% {
    background-position-x: 0px;
  }
  100% {
    background-position-x: 1000px;
  }
}
@keyframes animate2 {
  0%,
  100% {
    background-position-x: 1000px;
  }
  100% {
    background-position-x: 0px;
  }
}

//tap动画
@keyframes arise {
  0% {
    top: -80px;
  }
  100% {
    top: 0px;
  }
}
@keyframes packUp {
  0% {
    position: fixed;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 80px;
    top: 0px;
  }
  100% {
    position: fixed;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 80px;
    top: -80px;
  }
}

@keyframes companyTitleft {
  0% {
    // transform: translateX(-300px);
    padding-right: 600px;
    opacity: 0;
  }
  100% {
    // transform: translate(0);
    padding-right: 0px;
    opacity: 1;
  }
}

.tapAll {
  display: flex;
  justify-content: center;
  align-items: center;
  // top: -80px;
}
.tapPackUp {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: -130px;
  // top: -80px;
  animation: packUp 0.5s ease-out;
}
.tapPack {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: -130px;
}

.tapHome {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0px;
  z-index: 9999;
  width: 100%;
  background: white;
  height: 80px;
  animation: arise 0.5s ease-out;
}

@keyframes companyTitright {
  0% {
    // transform: translate(300px);
    padding-left: 600px;
    opacity: 0;
  }
  100% {
    transform: translate(0);
    padding-left: 0px;
    opacity: 1;
  }
}
.animLeft {
  animation: companyTitleft 3s ease-out;
}
.textLeft {
  width: 50%;
  margin: 0 40px;
  text-align: right;
}

.textImg {
  width: 310px;
}
.textRight {
  width: 50%;
  margin: 0 40px;
}
.animRight {
  animation: companyTitright 3s ease-out;
}
// .swiper-container {
//   // width: 75%;
//   height: auto;
//   margin-top: 80px;
//   margin-left: auto;
//   margin-right: auto;
// }
// /deep/.swiper-wrapper {
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
.my_slide {
  cursor: pointer;
  // margin: 0 20px;
  border-radius: 15px;
  font-size: 18px;
  // background: #fff;
  // height: 540px;
  // width: 420px !important;
  width: 330px !important;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // transition-property: all;
  // flex-direction: column;
  // text-align: center;
}
.swiperTit {
  padding: 30px 45px 20px 45px;
}
.swiperCont {
  padding: 0 45px;
}

.swiperBot {
  color: #f39800;
  text-align: right;
  padding: 20px;
}

.coreTechCont {
  position: relative;
  height: 100%;
  margin: 80px 0 0px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .coreSwiper {
    // padding-top: 60px;
    // width: 76%;
    // width: 1428px;
    /*  小屏适配 */
    // width: 87%;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: relative;
  }
  .coreTech {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    // color: #fff;
    padding-top: 20px;
  }
  .coreTit {
    font-size: 32px;
    font-weight: 600;
    text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.5);
  }
  .coreTxt {
    position: absolute;
    top: 55px;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
  }
  .compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 52px;
    width: 100%;
  }
  .compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  // .compe_txt {
  //   width: 100%;
  //   margin:60px 0px;
  //   text-align: center;
  // }
}
.textCont {
  height: 500px;
  margin: 80px 0 40px 0;
  background: #003365;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask {
  position: relative;
  width: 120px;
}
.maskImg {
  // display: block;
  // position: relative;
  width: 120px;
  // padding: 10px;
}
.overlay {
  position: absolute;
  background-color: rgba(31, 31, 31, 0.34);
  width: 100%;
  height: 100%;
  display: none;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
}
.mask:hover .overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
}
.overlay {
  position: absolute;
  background-color: rgba(31, 31, 31, 0.34);
  width: 100%;
  height: 100%;
  display: none;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
.overlayTit {
  font-size: 20px;
  font-weight: 600;
}
.mask:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 100%;
  // background-color: #39394357;
  background: #000000;
  opacity: 0;
  transition: opacity 0.5s;
  // border-radius: 15px;
  // box-shadow: 3px 3px 3px #999;
}
.mask:hover:before {
  opacity: 0.4;
}
.container_top {
  // padding-top: 50px;
  overflow: hidden;
  width: 100%;
  // height: 1500px;

  // background-repeat: no-repeat;
  // background-size: 100% 100%;

  // 中间内容 - 核心技术、核心能力、核心业务

  .centreCont {
    position: absolute;
    z-index: 99;
    top: 80%;
    // top: 760px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 76%;
    // width: 1405px;
    /*  小屏适配 */
    // width: 85%;
    width: 100%;
    max-width: 1182px;
    // margin: 0px auto;

    max-width: 1200px;
    margin: 0px auto;
    // margin-left: 35px;
  }
  .centre {
    // position: absolute;
    // z-index: 99;
    // top: 90%;
    // margin: 0 6.25%;
    // height: 300px;
    // background: #fff;
    // box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
    // display: flex;
    // justify-content: space-between;

    height: 300px;
    // width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);

    // 核心技术
    .techHover {
      transform: scale(1.1);
      // transform-origin: right;
      background: #155978;
      color: #fff !important;
      box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
    }
    .technology {
      // width: 33.3%;
      // height: 100%;
      // padding: 2% 5% 2%;
      // color: #04243d;
      // transition: all 0.3s ease-in-out;
      // cursor: pointer;

      height: 100%;
      color: #04243d;
      width: 100%;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      padding: 20px;

      &:hover {
        // transform: scale(1.1);
        // transform-origin: left;
        // background: #155978;
        // color: #fff;
        // box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
        transform: scale(1.1);
        // transform-origin: right;
        background: #155978;
        color: #fff !important;
        box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
      }

      .technology-warpper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        margin-left: 35px;
        .technology-title {
          display: flex;
          align-items: center;
          // justify-content: center;
          // margin: 0 14px;
          .title-text {
            margin-left: 20px;
            font-size: 28px;
            font-weight: bold;
          }
          img {
            // width: 30%;
            width: 120px;
            height: 120px;
          }
        }
        .technology-list {
          margin-top: 29px;
          display: flex;
          // justify-content: space-around;
          flex-wrap: wrap;
          font-size: 14px;
          div {
            margin-bottom: 16px;
          }
          div:nth-child(odd) {
            width: 162px;
          }
          // ul {
          //   display: flex;
          //   justify-content: space-between;
          //   flex-wrap: wrap;
          //   list-style: none;
          //   li {
          //     margin-bottom: 20px;
          //     font-size: 19px;
          //     font-weight: 400;
          //   }
          // }
        }
      }
    }
    // 核心能力
    .capacity {
      // padding: 2% 5% 2%;
      // width: 33.4%;
      height: 100%;
      color: #04243d;
      width: 100%;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      padding: 50px;
      &:hover {
        transform: scale(1.1);
        background: #155978;
        color: #fff;
        box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
      }
      .capacity-warpper {
        width: 100%;
        height: 100%;
        .capacity-title {
          display: flex;
          align-items: center;
          justify-content: center;
          .title-text {
            margin-left: 40px;
            font-size: 30px;
            font-weight: bold;
          }
        }
        .capacity-list {
          margin-top: 29px;
          ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            list-style: none;
            li {
              margin-bottom: 20px;
              font-size: 19px;
              font-weight: 400;
            }
          }
        }
      }
    }
    // 核心业务
    .business {
      // padding: 2% 5% 2%;
      // width: 33.3%;

      height: 100%;
      color: #04243d;
      width: 100%;
      transition: all 0.3s ease-in-out;
      cursor: pointer;
      padding: 50px;
      &:hover {
        transform: scale(1.1);
        transform-origin: right;
        background: #155978;
        color: #fff;
        box-shadow: 0px 8px 32px 3px rgba(5, 32, 55, 0.5);
      }
      .business-warpper {
        padding-top: 6px;
        width: 100%;
        height: 100%;
        .business-title {
          display: flex;
          align-items: center;
          justify-content: center;
          .title-text {
            margin-left: 20px;
            font-size: 35px;
            font-weight: bold;
          }
        }
        .business-list {
          margin-top: 35px;
          ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            list-style: none;
            li {
              margin-bottom: 20px;
              font-size: 19px;
              font-weight: 400;
            }
          }
        }
      }
    }
    // 分割线
    .line {
      margin: 80px 5px 60px;
      width: 3px;
      height: 156px;
      background: #0c3c5e;
    }
  }
  // 阴影
  // .shadow {
  //   height: 150px;
  //   background: #fff;
  //   transform: translateY(-150px);
  // }

  // @keyframes companyTitleft {
  //   0% {
  //     transform: translate(-600px);
  //     opacity: 0;
  //   }
  //   100% {
  //     transform: translate(0);
  //     opacity: 1;
  //   }
  // }
  // @keyframes companyTitright {
  //   0% {
  //     transform: translate(200px);
  //     opacity: 0;
  //   }
  //   100% {
  //     transform: translate(0);
  //     opacity: 1;
  //   }
  // }

  // 公司介绍
  .company {
    padding-top: 80px;
    height: 420px;
    background: #fff;
    //   transform: translateY(-150px);
    .company-warpper {
      margin: 0 6.25%;
      padding: 3% 4%;
      height: 370px;
      background: #e7eef1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .company_title {
        //   transform: translate(0);
        //   animation: companyTitleft 2s ease-out;
        margin: auto;
        margin-right: 80px;
        .title {
          margin-bottom: 19px;
          font-size: 29px;
          font-weight: bold;
          line-height: 28px;
        }
        .title-line {
          margin-bottom: 19px;
          width: 88px;
          height: 7px;
          background: #f39800;
          border-radius: 4px;
        }
        .title-en {
          font-size: 21px;
          font-weight: bold;
          line-height: 25px;
        }
      }
      .introduction_content {
        // transform: translate(0);
        //   animation: companyTitright 2s ease-out;
        font-size: 15px;
        font-weight: 400;
        color: #000000;
        line-height: 33px;
        text-indent: 2em;
        text-align: justify;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@media (max-width: $ipad-max-size) {
  #topCont {
    display: none;
  }
  #mobile {
    display: block !important;
  }
}
#mobile {
  display: none;
}
</style>
